module.exports = __webpack_public_path__ + "static/media/1656587759_4-illustration_png.d8ef3bc2.png";